import React from 'react';

import { ErrorMessages } from './SerialErrors';

export const SerialActions = ({ errorCode, serial, onRescan, onCancel }: any) => {
  return <ErrorMessages code={errorCode} serial={serial} onRescan={onRescan} onCancel={onCancel} />;
};
